import { render, staticRenderFns } from "./microsoft365-card.vue?vue&type=template&id=2a2a8126&scoped=true"
import script from "./microsoft365-card.vue?vue&type=script&lang=js"
export * from "./microsoft365-card.vue?vue&type=script&lang=js"
import style0 from "./microsoft365-card.vue?vue&type=style&index=0&id=2a2a8126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a8126",
  null
  
)

export default component.exports